<template functional>
  <div
    :class="data.staticClass"
    class="loader"
    v-bind="{...data.attrs, [parent.$options._scopeId]: ''}"
    v-on="listeners"
  >
    <i class="fas fa-spinner fa-pulse"></i>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style scoped lang="scss">
.loader {
  font-size: 20px;
  padding: 30px 0;
  text-align: center;
}
</style>
